import { StackView, Spinner, Button } from '@planningcenter/tapestry-react';
import React, { useCallback } from 'react';
import { ChannelList, InfiniteScroll } from 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import { useChannelsLoading } from '../../hooks/use_channels_loading.js';
import { useChat } from '../../hooks/use_chat.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { DrawerHeader } from '../../vendor/topbar/components/drawer_header.js';
import { DrawerHeading } from '../../vendor/topbar/components/drawer_heading.js';
import { BetaBadge } from '../beta_badge.js';
import { Subheading } from '../ui/subheading.js';
import { ChannelListBlankState } from './channel_list_blank_state.js';
import { LinkedAccountSelect } from './linked_account_select.js';
import { List } from './list.js';
import { Preview } from './preview.js';

const ChannelListView = ({ client, closeDrawer, hasConnectedPeople, env, appName, currentPersonId, }) => {
    const channelsLoading = useChannelsLoading();
    const { totalUnreadCount, markAllRead, markAllReadProcessing } = useChat();
    // Updating these filters might require changes in `handlePotentialChannelAddingEvent`
    const filters = {
        $or: [
            { last_message_at: { $exists: true } },
            { created_by_id: client.userID },
        ],
        members: { $in: [client.userID] },
        type: "messaging",
    };
    // If the above `filters` change we may need to update this logic as well.
    const handlePotentialChannelAddingEvent = useCallback(async (setChannels, event) => {
        const eventChannel = event.channel;
        if (!(eventChannel === null || eventChannel === undefined ? undefined : eventChannel.id))
            return;
        // Ensures empty conversations added by a different user are still hidden across event changes.
        const channelHasMessages = Boolean(eventChannel.last_message_at);
        if (!channelHasMessages)
            return;
        try {
            const newChannel = client.channel(eventChannel.type, eventChannel.id);
            await newChannel.watch();
            setChannels((channels) => [newChannel, ...channels]);
        }
        catch (error) {
            console.error(error);
        }
    }, [client.userID]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DrawerHeader, { closeDrawer: closeDrawer },
            React.createElement(StackView, { axis: "horizontal", alignment: "center", spacing: 1 },
                React.createElement(DrawerHeading, null, "Chat"),
                React.createElement(BetaBadge, null),
                channelsLoading && (React.createElement(Spinner, { color: "hsl(0 0% 62%)", thickness: 2, trackColor: "hsl(0 0% 97%)" })))),
        React.createElement(StackView, { spacing: 2, grow: 1 },
            hasConnectedPeople && (React.createElement(LinkedAccountSelect, { env: env, appName: appName, currentPersonId: currentPersonId })),
            React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 2, distribution: "space-between", paddingHorizontal: 2 },
                React.createElement(Subheading, null, "Conversations"),
                React.createElement(Button, { disabled: markAllReadProcessing, fontWeight: 400, left: "6px", onClick: markAllRead, size: "xs", spinner: markAllReadProcessing, theme: "primary", variant: "naked" },
                    "Mark ",
                    totalUnreadCount || "all",
                    " read")),
            React.createElement(ChannelList, { setActiveChannelOnMount: false, EmptyStateIndicator: ChannelListBlankState, filters: filters, onMessageNew: handlePotentialChannelAddingEvent, onAddedToChannel: handlePotentialChannelAddingEvent, List: List, 
                // Infinite scroll implementation details may need to be revisited once we have real data to work with.
                // https://getstream.io/chat/docs/sdk/react/guides/channel-list-infinite-scroll/#what-to-take-into-consideration
                Paginator: InfiniteScroll, Preview: Preview }))));
};

export { ChannelListView };
//# sourceMappingURL=index.js.map
